export const heroData = {
  title: '安斋拉拉',
  subtitle: '全方位主题落地页',
  description: '深度解析这一备受关注的名字背后的故事、作品与影响力。无论你是初次了解还是资深粉丝，这里汇聚关于安斋拉拉的最全内容，带你全方位认识她的魅力与价值。',
  ctaText: '探索更多',
  ctaLink: '/category/works',
  secondaryCtaText: '了解她',
  secondaryCtaLink: '/about',
};

export const statsData = [
  { label: '收录作品', value: '200+' },
  { label: '活跃粉丝', value: '50K+' },
  { label: '资讯文章', value: '300+' },
  { label: '荣誉奖项', value: '15+' },
];

export const featuresData = [
  {
    icon: 'ri-movie-2-line',
    title: '作品全集',
    description: '收录安斋拉拉出道至今全部作品信息，按时间线整理，支持分类检索与高清预览。',
    link: '/category/works',
  },
  {
    icon: 'ri-profile-line',
    title: '详细资料',
    description: '涵盖个人档案、职业生涯轨迹、获奖记录等全方位资料信息，随时更新最新数据。',
    link: '/category/profile',
  },
  {
    icon: 'ri-flashlight-line',
    title: '最新动态',
    description: '实时追踪安斋拉拉最新发布、活动动态与媒体报道，第一时间掌握新鲜资讯。',
    link: '/category/news',
  },
  {
    icon: 'ri-heart-line',
    title: '粉丝社区',
    description: '加入安斋拉拉粉丝大家庭，参与讨论、分享收藏、交流心得，与同好共聚。',
    link: '/category/community',
  },
];